var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollabOffer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.081,
    height: 32.081,
    viewBox: "0 0 32.081 32.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8626",
    "data-name": "Tracciato 8626",
    d: "M16.04,0A16.04,16.04,0,1,0,27.385,4.7,15.994,15.994,0,0,0,16.04,0Zm8.706,10.134c.568-.019,1.1.949.709,1.339l-7.088,7.089a2.667,2.667,0,0,1-1.373.733L7.451,21.927c-.607.167-1.239-.905-.822-1.322l7.088-7.089a2.664,2.664,0,0,1,1.373-.733l9.543-2.631A.5.5,0,0,1,24.746,10.134Zm-8.7,3.98a1.926,1.926,0,1,0,1.361.564A1.925,1.925,0,0,0,16.041,14.114Z",
    transform: "translate(0 0)",
    fill: "#7b7bff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabOffer);
export default __webpack_public_path__ + "static/media/collabOffer.20462d833ee517e5ef74032870d8f139.svg";
export { ForwardRef as ReactComponent };